import Overview from '@rebuild/materials/shared/investment_activity/FlowOverviewPC.vue';
import FullIndex from '@rebuild/materials/shared/investment_activity/FullIndex.vue';
import MobOverviewIndex from '@rebuild/materials/shared/investment_activity/mobile/OverviewIndex.vue';
import MobFullIndex from '@rebuild/materials/shared/investment_activity/mobile/FullIndex.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/investment_activity/context';

function useSelfContext() {
	provideCurrentContext();
}

export const componentMap = {
	overview: withProvider(Overview, useSelfContext),
	full: withProvider(FullIndex, useSelfContext),
	'mob-overview': withProvider(MobOverviewIndex, useSelfContext),
	'mob-full': withProvider(MobFullIndex, useSelfContext)
};
